import "./card_loisirs.css";
import MediaRessources from "../../ressources/media-ressources";

function Card_Loisirs({ imageUrl, imageAlt, titleCard, textCard }) {
  return (
    <div className="card-loisirs">
      <div className="card-loisirs-img">
        <figure className="figure-card-loisirs">
          <img src={imageUrl} alt={imageAlt} className="card-image" />
        </figure>
      </div>
      <div className="article-body">
        <div className="box-title-card-loisirs">
          <h2 className="title-card-loisirs">{titleCard}</h2>
          <img
            className="trait-loisirs"
            src={MediaRessources.traitService}
            alt="Trait de séparation entre le titre et les textes des services proposés"
          />
        </div>

        <div
          className="content-card-loisirs"
          dangerouslySetInnerHTML={{ __html: textCard }}
        ></div>
      </div>
    </div>
  );
}

export default Card_Loisirs;
